'use client';

import Header from '@/components/Header';
import Footer from '@/components/Footer';
import Link from 'next/link';

export default function PrivacyPolicyPage() {
  return (
    <>
      <Header lang="it" />
      <main style={{ background: '#071520', minHeight: '100vh' }}>
        {/* Hero */}
        <section
          style={{
            background: 'linear-gradient(180deg, #0B1F2E 0%, #071520 100%)',
            borderBottom: '1px solid rgba(240,247,255,0.06)',
            padding: '64px 0 48px',
          }}
        >
          <div className="container-main" style={{ maxWidth: '800px' }}>
            <p style={{ fontSize: '12px', fontWeight: 700, letterSpacing: '0.12em', textTransform: 'uppercase', color: '#00D4FF', marginBottom: '12px' }}>
              Documenti legali
            </p>
            <h1
              style={{
                fontFamily: 'Fraunces, Georgia, serif',
                fontSize: 'clamp(28px, 5vw, 44px)',
                fontWeight: 700,
                color: '#F0F7FF',
                lineHeight: 1.2,
                marginBottom: '16px',
              }}
            >
              Privacy Policy
            </h1>
            <p style={{ fontSize: '15px', color: 'rgba(240,247,255,0.5)', lineHeight: 1.7 }}>
              Ultimo aggiornamento: aprile 2025
            </p>
          </div>
        </section>

        {/* Content */}
        <section style={{ padding: '56px 0 80px' }}>
          <div className="container-main" style={{ maxWidth: '800px' }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '48px' }}>

              <LegalSection title="Chi siamo e come contattarci">
                <p>
                  Il titolare del trattamento dei dati personali è <strong style={{ color: '#F0F7FF' }}>Federico De Nigris</strong>, titolare di E-Foil Experience, con sede in Via Vincenzo Bellini 3, P.IVA 02812640031.
                </p>
                <p>
                  Per qualsiasi domanda relativa alla privacy o al trattamento dei tuoi dati, puoi scriverci a:{' '}
                  <a href="mailto:info@e-foilexperience.com" style={{ color: '#00D4FF' }}>info@e-foilexperience.com</a>
                </p>
              </LegalSection>

              <LegalSection title="Quali dati raccogliamo">
                <p>Raccogliamo solo i dati necessari per gestire le prenotazioni e fornirti il servizio:</p>
                <DataTable items={[
                  { type: 'Nome e cognome', purpose: 'Identificazione del partecipante' },
                  { type: 'Indirizzo email', purpose: 'Conferma prenotazione e comunicazioni' },
                  { type: 'Numero di telefono', purpose: 'Contatto in caso di necessità' },
                  { type: 'Dati di prenotazione', purpose: 'Data, orario, esperienza scelta, numero di partecipanti' },
                  { type: 'Dati di pagamento', purpose: 'Elaborati in modo sicuro da provider di pagamento certificati. Non abbiamo accesso né conserviamo i dati completi della carta.' },
                  { type: 'Firma digitale', purpose: 'Liberatoria di partecipazione obbligatoria' },
                ]} />
                <p>
                  Non raccogliamo né trattiamo dati sensibili (come informazioni sulla salute), salvo quelli che il partecipante decide di comunicarci volontariamente e solo se strettamente necessari per la sicurezza dell'attività.
                </p>
              </LegalSection>

              <LegalSection title="Perché trattiamo i tuoi dati">
                <p>I tuoi dati vengono utilizzati esclusivamente per le seguenti finalità:</p>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                  {[
                    { title: 'Gestione della prenotazione', desc: 'Confermare, modificare o cancellare la tua prenotazione' },
                    { title: 'Erogazione del servizio', desc: 'Organizzare la sessione, il briefing e l\'assistenza in loco' },
                    { title: 'Comunicazioni operative', desc: 'Inviarti conferme, promemoria e aggiornamenti sulla tua prenotazione' },
                    { title: 'Adempimenti legali', desc: 'Conservare i documenti richiesti dalla normativa vigente' },
                    { title: 'Assistenza post-servizio', desc: 'Rispondere a eventuali richieste o reclami' },
                  ].map((item, i) => (
                    <div
                      key={i}
                      style={{
                        background: 'rgba(240,247,255,0.03)',
                        border: '1px solid rgba(240,247,255,0.07)',
                        borderRadius: '10px',
                        padding: '14px 18px',
                      }}
                    >
                      <p style={{ fontSize: '14px', fontWeight: 700, color: '#F0F7FF', marginBottom: '4px' }}>{item.title}</p>
                      <p style={{ fontSize: '14px', color: 'rgba(240,247,255,0.6)', lineHeight: 1.6 }}>{item.desc}</p>
                    </div>
                  ))}
                </div>
                <p>
                  Non utilizziamo i tuoi dati per finalità di marketing senza il tuo esplicito consenso.
                </p>
              </LegalSection>

              <LegalSection title="Base giuridica del trattamento">
                <p>Il trattamento dei tuoi dati si basa su:</p>
                <ul style={{ display: 'flex', flexDirection: 'column', gap: '10px', paddingLeft: '0', listStyle: 'none' }}>
                  {[
                    'Esecuzione del contratto: i dati sono necessari per gestire la prenotazione e fornire il servizio',
                    'Obbligo legale: conservazione di documenti fiscali e contabili',
                    'Legittimo interesse: gestione della sicurezza e prevenzione di comportamenti non idonei',
                    'Consenso: per eventuali comunicazioni promozionali, solo se esplicitamente fornito',
                  ].map((item, i) => (
                    <li key={i} style={{ display: 'flex', gap: '10px', alignItems: 'flex-start', color: 'rgba(240,247,255,0.75)', fontSize: '15px', lineHeight: 1.6 }}>
                      <span style={{ color: '#00D4FF', fontWeight: 700, flexShrink: 0, marginTop: '2px' }}>→</span>
                      {item}
                    </li>
                  ))}
                </ul>
                <p>
                  Il conferimento dei dati necessari alla prenotazione è obbligatorio per poter usufruire del servizio. Il mancato conferimento può comportare l'impossibilità di completare la prenotazione.
                </p>
              </LegalSection>

              <LegalSection title="Come trattiamo i tuoi dati">
                <p>
                  I tuoi dati sono trattati in modo sicuro, con misure tecniche e organizzative adeguate a prevenire accessi non autorizzati, perdite o divulgazioni.
                </p>
                <p>
                  Il trattamento avviene principalmente in forma digitale, tramite sistemi protetti. L'accesso è limitato al titolare e, ove necessario, ai fornitori tecnici che supportano il servizio.
                </p>
              </LegalSection>

              <LegalSection title="Fornitori tecnici e terze parti">
                <p>
                  Per erogare il servizio, ci avvaliamo di fornitori tecnici selezionati che trattano i dati per nostro conto come responsabili del trattamento. Tra questi rientrano:
                </p>
                <ul style={{ display: 'flex', flexDirection: 'column', gap: '10px', paddingLeft: '0', listStyle: 'none' }}>
                  {[
                    'Provider di hosting e infrastruttura del sito web',
                    'Sistema di gestione delle prenotazioni online',
                    'Provider di pagamento certificato (elaborazione sicura delle transazioni)',
                    'Servizio di invio email transazionali (conferme, promemoria)',
                  ].map((item, i) => (
                    <li key={i} style={{ display: 'flex', gap: '10px', alignItems: 'flex-start', color: 'rgba(240,247,255,0.75)', fontSize: '15px', lineHeight: 1.6 }}>
                      <span style={{ color: '#00D4FF', fontWeight: 700, flexShrink: 0, marginTop: '2px' }}>→</span>
                      {item}
                    </li>
                  ))}
                </ul>
                <p>
                  Tutti i fornitori sono selezionati per la loro affidabilità e operano nel rispetto del GDPR. Non vendiamo né cediamo i tuoi dati a terzi per finalità commerciali.
                </p>
                <p>
                  I fornitori trattano i dati esclusivamente per conto del titolare e secondo istruzioni specifiche, nel rispetto della normativa applicabile in materia di protezione dei dati.
                </p>
              </LegalSection>

              <LegalSection title="Conservazione dei dati">
                <p>
                  I dati relativi alle prenotazioni sono conservati per il tempo necessario all'erogazione del servizio e, successivamente, per il periodo richiesto dagli obblighi legali e fiscali (generalmente fino a 10 anni).
                </p>
                <p>
                  Le firme digitali delle liberatorie sono conservate per il periodo necessario a tutela legale dell'attività.
                </p>
                <p>
                  I dati non più necessari vengono eliminati o anonimizzati.
                </p>
              </LegalSection>

              <LegalSection title="I tuoi diritti">
                <p>In qualità di interessato, hai il diritto di:</p>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '10px' }}>
                  {[
                    { right: 'Accesso', desc: 'Sapere quali dati abbiamo su di te' },
                    { right: 'Rettifica', desc: 'Correggere dati inesatti o incompleti' },
                    { right: 'Cancellazione', desc: 'Richiedere la rimozione dei tuoi dati' },
                    { right: 'Limitazione', desc: 'Limitare il trattamento in certi casi' },
                    { right: 'Portabilità', desc: 'Ricevere i tuoi dati in formato leggibile' },
                    { right: 'Opposizione', desc: 'Opporti al trattamento per legittimo interesse' },
                  ].map((item, i) => (
                    <div
                      key={i}
                      style={{
                        background: 'rgba(0,212,255,0.04)',
                        border: '1px solid rgba(0,212,255,0.12)',
                        borderRadius: '10px',
                        padding: '14px 16px',
                      }}
                    >
                      <p style={{ fontSize: '13px', fontWeight: 700, color: '#00D4FF', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.06em' }}>{item.right}</p>
                      <p style={{ fontSize: '13px', color: 'rgba(240,247,255,0.6)', lineHeight: 1.5 }}>{item.desc}</p>
                    </div>
                  ))}
                </div>
                <p>
                  Per esercitare i tuoi diritti, scrivi a <a href="mailto:info@e-foilexperience.com" style={{ color: '#00D4FF' }}>info@e-foilexperience.com</a>. Risponderemo nei tempi previsti dalla normativa applicabile.
                </p>
                <p>
                  Hai inoltre il diritto di presentare reclamo al Garante per la Protezione dei Dati Personali (www.garanteprivacy.it).
                </p>
              </LegalSection>

              <LegalSection title="Cookie">
                <p>
                  Il sito utilizza cookie tecnici e, previo consenso, cookie analitici. Per maggiori dettagli, puoi consultare la nostra{' '}
                  <Link href="/it/cookie-policy" style={{ color: '#00D4FF' }}>Cookie Policy</Link>.
                </p>
              </LegalSection>

            </div>
          </div>
        </section>
      </main>
      <Footer lang="it" />
    </>
  );
}

function LegalSection({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div>
      <h2
        style={{
          fontFamily: 'Fraunces, Georgia, serif',
          fontSize: '22px',
          fontWeight: 700,
          color: '#F0F7FF',
          marginBottom: '20px',
          paddingBottom: '12px',
          borderBottom: '1px solid rgba(240,247,255,0.08)',
        }}
      >
        {title}
      </h2>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
        {children}
      </div>
    </div>
  );
}

function DataTable({ items }: { items: { type: string; purpose: string }[] }) {
  return (
    <div
      style={{
        border: '1px solid rgba(240,247,255,0.08)',
        borderRadius: '12px',
        overflow: 'hidden',
      }}
    >
      {items.map((item, i) => (
        <div
          key={i}
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr 2fr',
            gap: '16px',
            padding: '14px 20px',
            background: i % 2 === 0 ? 'rgba(240,247,255,0.02)' : 'transparent',
            borderBottom: i < items.length - 1 ? '1px solid rgba(240,247,255,0.06)' : 'none',
          }}
        >
          <span style={{ fontSize: '13px', fontWeight: 700, color: 'rgba(240,247,255,0.7)' }}>{item.type}</span>
          <span style={{ fontSize: '13px', color: 'rgba(240,247,255,0.55)', lineHeight: 1.5 }}>{item.purpose}</span>
        </div>
      ))}
    </div>
  );
}
